import { cn } from "@/components/podkit/lib/cn";
import { Text } from "@/components/podkit/typography/Text";
import type { FC } from "react";
import { Triangle } from "./TrendTriangle";

type Props = {
    title: string;
    value: string;
    trend: number;

    selected?: boolean;
    isLoading?: boolean;

    handleClick?: () => void;
};
export const UsageCard: FC<Props> = ({ title, value, trend, isLoading, selected, handleClick }) => {
    return (
        <button
            className={cn("flex w-full flex-col gap-2 rounded-xl bg-surface-glass px-4 py-3 text-left", {
                "border-2 border-content-orange bg-surface-02": selected,
                "border-0.5 border-border-base hover:bg-surface-02": !selected,
            })}
            onClick={handleClick}
        >
            <Text className="text-sm font-bold">{title}</Text>
            <div className="flex flex-row items-center gap-4">
                <Text className="text-2xl font-bold">{value}</Text>
                {!isLoading && (
                    <Text
                        className={cn("flex flex-row items-center gap-1 text-base", {
                            "text-content-red": trend < 0,
                            "text-content-green": trend > 0,
                        })}
                    >
                        {(trend * 100).toFixed(0)}% <Triangle trendUp={trend >= 0} />
                    </Text>
                )}
            </div>
        </button>
    );
};
